import React from 'react'
import {
  Button,
  DialogContentText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
} from '@material-ui/core'

class DialogConfirmation extends React.Component {
  render() {
    return (
      <Dialog open={this.props.open} onClose={this.props.handleClose}>
        {this.props.isLoading && <LinearProgress />}
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{this.props.desc || ''}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.props.isLoading}
            color="secondary"
            onClick={this.props.handleConfirm}
          >
            {this.props.action || 'Sure'}
          </Button>
          <Button color="primary" onClick={this.props.handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default DialogConfirmation



// WEBPACK FOOTER //
// ./src/main/content/utils/DialogConfirmation.js